import { fromBackendPermissions, type Workspace } from '@shared/domain/permissions'
import type { MeResponse } from '../session.api'
import type { ActorType, LoginResponse, LoginScope } from './auth.api'
import { decodeJwt } from './jwt'

/** Banks (FIs) and the platform team both work in the Ops workspace (spec §2). */
export const WORKSPACE_BY_ACTOR: Record<ActorType, Workspace> = {
  PLATFORM_ADMIN: 'ops',
  FINANCIAL_INSTITUTION: 'ops',
  ANCHOR: 'anchor',
  SUPPLIER: 'supplier',
}

/**
 * The backend has no GET /me yet, so the session is built from the login response.
 * The org's activation status is not part of it, so the onboarding gate stays open
 * (see useOrgStore().isActive) until an org-status endpoint is wired in.
 */
export function sessionFromLogin(res: LoginResponse, scope?: LoginScope): MeResponse {
  if (!res.accessToken || !res.actorType) throw new Error('Login response has no session')
  const workspace = WORKSPACE_BY_ACTOR[res.actorType]
  const orgName =
    scope?.orgName ?? res.availableScopes.find((s) => s.orgId === res.orgId)?.orgName ?? ''
  return {
    user: {
      id: decodeJwt(res.accessToken).sub ?? res.email,
      name: res.fullName,
      email: res.email,
      workspace,
      actorType: res.actorType,
      roles: [res.actorType],
      permissions: fromBackendPermissions(res.permissions),
      mfa: false,
    },
    organisation: {
      id: res.orgId ?? 'platform',
      name: orgName,
      type: workspace,
      programmeIds: [],
    },
  }
}
